import { SVGProps } from 'react';

const Trash = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M14.25 4a.25.25 0 0 0-.201-.245L14 3.75h-4a.25.25 0 0 0-.25.25v2.25h4.5V4ZM6.747 18.938c.002.02.003.041.003.062A1.25 1.25 0 0 0 8 20.25h8A1.25 1.25 0 0 0 17.25 19l.003-.063.933-11.187H5.814l.933 11.188ZM9.25 17v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-1.5 0Zm4 0v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-1.5 0Zm2.5-10.75H20a.75.75 0 0 1 0 1.5h-.31l-.943 11.313A2.747 2.747 0 0 1 16 21.75H8a2.75 2.75 0 0 1-2.747-2.688L4.31 7.75H4a.75.75 0 0 1 0-1.5h4.25V4A1.75 1.75 0 0 1 10 2.25h4A1.75 1.75 0 0 1 15.75 4v2.25Z"
    />
  </svg>
);

export default Trash;
